import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

function Landing() {
  const history = useHistory();
  const isUser = useSelector((state) => state.ui.isUser);

  useEffect(() => {
    if (isUser.kol || isUser.project) {
      history.push("/dashboard");
    }
  }, [isUser]);

  return (
    <div style={{ height: "100%" }}>
      {!isUser.kol || !isUser.project ? <Hero /> : null}
    </div>
  );
}

export default Landing;
